import React from 'react';
import './page-divider.css';

const PageDivider = () => {
  return (
    <div className="container-fluid page-divider mg-top-10 mg-top-20" />
  );
};

export default PageDivider;



// WEBPACK FOOTER //
// ./src/components/common/divider/index.jsx